import { useEffect } from 'react';

import { useAtom, useAtomValue } from 'jotai';

import { useSearchObjectToParams } from '../../../../src/hooks/router/searchParams';
import { tableSearchListAtom, tableSearchParamsAtom } from '../../Search/store';
import { useTableContext } from '../../table.context';

const TableSearchQueryClient = () => {
  const { atomStore } = useTableContext();

  /** Search Object from the Table */
  const [searchObject] = useAtom(tableSearchParamsAtom, {
    store: atomStore,
  });

  /** Updater for the url query params */
  const { updateSearchParams } = useSearchObjectToParams({
    searchObject,
    withPagination: false,
  });

  //** List of current inputs on the table */
  const searchInputList = useAtomValue(tableSearchListAtom, { store: atomStore });

  useEffect(() => {
    // Ensure there are inputs to update the state and also don't blow away the search params if there are no inputs
    if (searchInputList.length && Object.keys(searchObject).length !== 0) {
      updateSearchParams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- SearchInputList is needed for dynamic search input fields that may be fetched via RPC
  }, [searchInputList, searchObject]);

  return null;
};

export { TableSearchQueryClient };
